module.exports = __webpack_public_path__ + "img/christianeendler.349469a0.jpg";